export const OVER = '' as const;
export const IN = 'in' as const;
export const ON = 'over' as const;

export const FLOAT_LABEL_VARIANTS = {
  OVER,
  IN,
  ON,
} as const;
